// src/design-system/Button.tsx
import clsx from "clsx";
import { Loader2 } from "lucide-react";
import type { ButtonHTMLAttributes } from "react";

type Variant = "default" | "gold" | "outline" | "danger";

type Props = ButtonHTMLAttributes<HTMLButtonElement> & { variant?: Variant; small?: boolean; loading?: boolean };

const CLS: Record<Variant, string> = { default: "", gold: "btn-gold", outline: "btn-gold-outline", danger: "btn-danger" };

export function Button({ variant = "default", small, loading, className, children, disabled, type = "button", ...rest }: Props) {
  return (
    <button
      type={type}
      className={clsx("btn", CLS[variant], small && "btn-sm", className)}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...rest}
    >
      {loading && <Loader2 size={14} className="animate-spin" aria-hidden />}
      {children}
    </button>
  );
}
